import Icon from '@/components/snippets/icon/icon'
import { useSort } from 'libs/searchspring/hooks/useSort'

export function FilterSort({ id = 'sort' }) {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  return (
    <x-modal className="group" data-id={id}>
      <button
        className="flex items-center gap-x-0.5 link-fade"
        data-modal-parent={id}
        data-modal-role="toggle"
        aria-label="Toggle Sort By"
      >
        <div class="w-[16px] h-[14px] children:size-full">
          <Icon id="sort" />
        </div>
        <span className="text-xxs lg:text-xs font-ext font-bold uppercase">
          Sort by{activeSort ? <span className="hidden lg:inline">: {sorts.find(sort => sort.value === activeSort)?.label}</span> : ''}
        </span>
      </button>
      <div
        className="flex flex-col fixed lg:absolute bottom-0 lg:top-full right-0 w-full lg:w-fit h-fit bg-secondary lg:opacity-0 lg:group-data-visible:opacity-100 translate-y-full lg:border-l lg:border-b lg:border-neutral-light lg-max:group-data-visible:translate-y-0 lg:translate-y-px pointer-events-none group-data-visible:pointer-events-auto z-70 lg:z-40 transition-all"
      >
        <div className="shrink-0 flex gap-x-1 items-center justify-between w-full h-[52px] md:h-[60px] pl-margin pr-0.5 lg:pl-1.5 lg:pr-0.75 lg-max:border-b lg-max:border-neutral-light">
          <h2 className="h6 lg:text-l font-cnd font-bold uppercase whitespace-nowrap">Sort By</h2>
          <button
            class="shrink-0 flex items-center justify-center size-[25px] link-fade"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Sort By"
          >
            <div class="size-[13px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        </div>
        <div className="flex flex-col gap-y-1.875 px-margin lg:px-1.5 pt-1 pb-2">
          <div className="flex items-center gap-x-0.5 w-fit cursor-pointer">
            <input
              id={'sort__default'}
              className="field-radio"
              type="radio"
              value='default'
              name="sort"
              onClick={() => resetSort()}
              checked={!activeSort}
              aria-label="Recommended"
            />
            <label for={'sort__default'} className="text-s whitespace-nowrap cursor-pointer">
              Recommended
            </label>
          </div>
          {sorts?.map((sort) => (
            <div className="flex items-center gap-x-0.5 w-fit cursor-pointer">
              <input
                id={`sort__${sort.value}`}
                className="field-radio"
                type="radio"
                value={sort.value}
                name="sort"
                onClick={() => handleSort(sort.value)}
                checked={activeSort === sort.value}
                aria-label={sort.label}
              />
              <label for={`sort__${sort.value}`} className="text-s whitespace-nowrap cursor-pointer">
                {sort.label}
              </label>
            </div>
          ))}
        </div>
      </div>
      <button
        class="lg:hidden fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible:opacity-100 pointer-events-none group-data-visible:pointer-events-auto cursor-s-resize z-60 transition-all"
        data-modal-parent={id}
        data-modal-role="close"
        aria-label="Close Sort By"
      >
      </button>
    </x-modal>
  )
}
